<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-select
      :field="titleClassesField"
      class="col-8"
      :label="`${(conditional.conditionsRequirements[excludeTitleClassesField] ? 'Exclude' : 'Include')} Title Classes`"
      :options="titleClasses.data"
      option-label="name"
      option-value="id"
      map-options
      emit-value
      multiple
      use-chips
      clearable
      :rules="[
        val => !!val || 'Field is required',
        val => val.length > 0 || 'Must select at least one title class'
      ]"
    >
      <template #option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            {{ scope.opt.name }}
          </q-item-section>
        </q-item>
      </template>
    </model-form-select>
    <model-form-toggle
      :field="`conditionsRequirements.${excludeTitleClassesField}`"
      class="col-4 q-mb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITION_REQUIREMENTS } from 'src/models/membership-type/MembershipPoint'

export default {
  name: 'TitleClassesConditionForm',
  configuration: ['titleClasses'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    titleClassesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.TITLE_CLASSES
    },
    excludeTitleClassesField: {
      type: String,
      default: CONDITION_REQUIREMENTS.EXCLUDE_TITLE_CLASSES
    }
  }
}

</script>
